export default "__VITE_ASSET__BvLdMY7d__"